export const SupplierUserOrders = {
  USERS: { label: 'Users', value: "Users" },
  ASSOCIATIONS: { label: 'Association', value: "Associations" },
  LOCATIONS: { label: 'Locations', value: "Locations" },
  PURCHASEORDERS: { label: 'Puchaseorders', value: "Purchaseorders" }
};

